angular.module('avant.customer_applications.directives').directive 'amountLoanAmountSelector', [
  "$filter", "ProductService", "$q", "ApplicationService",
  ($filter, ProductService, $q, ApplicationService) ->
    restrict: 'E'
    scope:
      amountInterval: '@'
      attrName: '@'
      captionContent: '@'
      config: '='
      clientSideErrors: '@'
      errorIcon: '@'
      inputUsedForUpdate: '='
      labelContent: '@'
      manualAmount: '='
      ngClass: '@'
      objectName: '@'
      product: '='
      refinance: '='
      refinancePayoffAmount: '='
      requestedLoanAmountError: '='
      serverErrors: '='
      serverSideErrorFields: '='
      showExactAmount: '='
      sublabelContent: '@'
      submittingPage: '='
    template: '''
      <section class="form__stack">
        <div class="form__row">
          <div class="form__group">
            <label
              class="form__label label label--primary"
              for="{{ fieldNameUnderscore }}"
              ng-if="labelContent"
            >
              {{ labelContent }}
            </label>
            <small class="form__blurb" id="{{ fieldNameUnderscore }}_sublabel" ng-if="sublabelContent">
              {{ sublabelContent }}
            </small>

            <input
              aria-describedby="{{ manualInputAriaDescribedBy }}"
              aria-required="true"
              class="form__input form__input--dollar"
              name="{{ fieldNameUnderscore }}"
              id="{{ fieldNameUnderscore }}"
              min="{{ product.minimum_borrow_amount }}"
              max="{{ product.maximum_borrow_amount }}"
              ng-change="manualUpdate()"
              ng-class="ngClasses()"
              ng-model="manualAmount"
              step="{{ amountInterval }}"
              type="number"
            >
            </input>
            <span class="hide-display" id="minLoanAmount">
              Minimum loan amount of ${{ product.minimum_borrow_amount }}.
            </span>
            <span class="hide-display" id="maxLoanAmount">
              Maximum loan amount of ${{ product.maximum_borrow_amount }}.
            </span>

            <small
              aria-live="polite"
              class="form__error"
              id="{{ fieldNameUnderscore }}_client_error"
              ng-if="!!requestedLoanAmountError"
              role="alert"
            >
              <amount-icon
                ng-if="errorIcon"
                css-classes="icon-brand-primary"
                icon-name="#icon-circle-delete"
                aria-hidden="true"
              >
              </amount-icon>
              {{ requestedLoanAmountError }}
            </small>
            <p class="form__error" ng-repeat="serverError in serverErrors">
              {{ serverError }}
            </p>
            <small class="form__blurb" id="{{ fieldNameUnderscore }}_caption" ng-if="captionContent">
              {{ captionContent }}
            </small>
          </div>
        </div>
      </section>

      <section class="loan-option__slider">
        <label class="hide-display" for="{{ fieldNameUnderscore }}_slider">
          Loan amount slider.
        </label>
        <input
          aria-describedby="{{ sliderInputAriaDescribedBy }}"
          id="{{ sliderInputId }}"
          max="{{ product.maximum_borrow_amount }}"
          min="{{ product.minimum_borrow_amount }}"
          type="range"
          step="{{ amountInterval }}"
          value="{{ product.requested_amount }}"
        >
        </input>
        <span>
          {{ minimumBorrowAmountFormatted() }}
        </span>
        <span class="slider-max">
          {{ maximumBorrowAmountFormatted() }}
        </span>
      </section>
    '''
    link: (scope, element) ->
      scope.fieldNameDot = "#{scope.objectName}.#{scope.attrName}"
      scope.fieldNameUnderscore = "#{scope.objectName}_#{scope.attrName}"
      scope.sliderInputId = "#{scope.fieldNameUnderscore}_slider"

      element.bind 'change', ($event) ->
        if $event.target.id == scope.sliderInputId
          scope.sliderUpdate(parseInt(angular.element("##{scope.sliderInputId}")[0].value))

      scope.manualInputAriaDescribedBy = """
        minLoanAmount maxLoanAmount #{scope.fieldNameUnderscore}_sublabel
        #{scope.fieldNameUnderscore}_caption #{scope.fieldNameUnderscore}_client_error
      """
      scope.sliderInputAriaDescribedBy = """
        minLoanAmount maxLoanAmount #{scope.fieldNameUnderscore}_sublabel
        #{scope.fieldNameUnderscore}_client_error
      """
      scope.minimumBorrowAmountFormatted = ->
        $filter("ProductMoney")(scope.product.minimum_borrow_amount, scope.config, 0)

      scope.maximumBorrowAmountFormatted = ->
        $filter("ProductMoney")(scope.product.maximum_borrow_amount, scope.config, 0)

      scope.ngClasses = ->
        classes = {}
        classes[scope.ngClass] = !!(scope.requestedLoanAmountError || scope.serverSideErrorFields.indexOf(scope.fieldNameUnderscore) >= 0)
        classes

      scope.manualUpdate = ->
        validateInput()
        return if scope.manualAmount == scope.product.requested_amount
        scope.inputUsedForUpdate = "##{scope.fieldNameUnderscore}"
        unless scope.requestedLoanAmountError
          debouncedUpdateProductAmount(scope.manualAmount)

      scope.sliderUpdate = (amount) ->
        scope.manualAmount = amount
        validateInput()
        scope.inputUsedForUpdate = "##{scope.sliderInputId}"
        unless scope.requestedLoanAmountError
          updateProductAmount(amount)

      debouncedUpdateProductAmount = _.debounce(
        (newRequestedAmount) -> updateProductAmount(newRequestedAmount),
        800
      )

      updateProductAmount = (newRequestedAmount) ->
        scope.$emit "requested_amount_changed", newRequestedAmount
        borrowAmount = newRequestedAmount
        borrowAmount += scope.refinancePayoffAmount if scope.refinance
        borrowAmount += scope.product.fees if scope.product.fees
        if scope.refinance
          if scope.showExactAmount
            borrowAmount = ProductService.roundToNearestCent(borrowAmount / (1 - scope.product.administration_fee_rate))
          else
            borrowAmount = Math.round(borrowAmount / (1 - scope.product.administration_fee_rate))
        updateAmount(borrowAmount)

      updateAmount = (amount) ->
        appId = ApplicationService.target_application_id()
        return unless appId
        scope.product.loans = []
        deferred = $q.defer()
        unless scope.submittingPage
          clearSelectedLoan()
          ProductService.update(appId, { borrow_amount: amount }).then ->
            if scope.product.requested_amount != scope.manualAmount
              validateInput()
              unless scope.requestedLoanAmountError
                updateProductAmount(scope.manualAmount)
              return deferred.resolve()
            scope.manualAmount = scope.product.requested_amount
            angular.element("##{scope.sliderInputId}")[0].value = scope.product.requested_amount.toString()
            amount = ProductService.getBorrowAmount()
            deferred.resolve()
        deferred.promise

      validateInput = ->
        amount = scope.manualAmount
        min = scope.product.minimum_requestable_amount
        max = scope.product.maximum_requestable_amount
        errorMessages = JSON.parse(scope.clientSideErrors)

        if !(amount && amount >= min && amount <= max)
          scope.requestedLoanAmountError = errorMessages.valid_range
        else if !(amount in scope.product.requestable_loan_amounts)
          scope.requestedLoanAmountError = errorMessages.valid_increment
        else
          scope.requestedLoanAmountError = null

      clearSelectedLoan = ->
        scope.product.selected_loan = null
  ]
